import api from '@/services/api'
import { useAnalytics } from '@/composables/analytics'
import { usePlayer, wasDormant } from '@/composables/game/player'
import { computed, watch } from 'vue'
import { useLocalStorage } from '@vueuse/core'
import { buildDropeeStorageKey } from '@/config/config'
import { showHiddenFeatures } from '@/composables/feature-flag'

export const useOnboarding = () => {
  const { triggerEvent, setUserProperty } = useAnalytics()
  const { player, updatePlayer } = usePlayer()

  const isOnboardingDone = computed(() => player.value.onboarding.done)

  async function doOnboarding() {
    const { playerStats, isReferred } = await api.onboardingDone()
    updatePlayer(playerStats)
    triggerEvent({ event: 'tutorial_complete' })
    triggerEvent({ event: isReferred ? 'referral' : 'non_referral' })
    setUserProperty({ acquisition: isReferred ? 'referral' : 'direct' })
  }

  return {
    doOnboarding,
    isOnboardingDone,
  }

}

const showOnboardingEmojiWheel = useLocalStorage(buildDropeeStorageKey('onboarding_emoji_wheel'), true)
const showOnboardingEmojiNavbarHome = useLocalStorage(buildDropeeStorageKey('onboarding_emoji_navbar_home'), false)
const showOnboardingEmojiTapSection = useLocalStorage(buildDropeeStorageKey('onboarding_emoji_tap_section'), true)
const showOnboardingEmojiNavbarImprove = useLocalStorage(buildDropeeStorageKey('onboarding_emoji_navbar_improve'), false)
const showOnboardingEmojiCard = useLocalStorage(buildDropeeStorageKey('onboarding_emoji_card'), true)
const showOnboardingEmojiNavbarQuests = useLocalStorage(buildDropeeStorageKey('onboarding_emoji_navbar_quests'), false)
const showOnboardingEmojiQuest = useLocalStorage(buildDropeeStorageKey('onboarding_emoji_quest'), true)
const showOnboardingEmojiNavbarFriends = useLocalStorage(buildDropeeStorageKey('onboarding_emoji_navbar_friends'), false)
const showOnboardingEmojiFriends = useLocalStorage(buildDropeeStorageKey('onboarding_emoji_friends'), true)

export const useOnboardingFingerEmojis = () => {
  const { player } = usePlayer()
  const canShowOnboardingEmoji = computed(() => !showHiddenFeatures.value && (player.value.level <= 1 || wasDormant.value))

  watch(showOnboardingEmojiWheel, (showOnboardingEmojiWheel, oldValue) => {
    if (!showOnboardingEmojiWheel && oldValue) {
      setTimeout(() => {
        showOnboardingEmojiNavbarHome.value = true
      }, 8000)
    }
  })

  watch(showOnboardingEmojiTapSection, (showOnboardingEmojiTapSection, oldValue) => {
    if (!showOnboardingEmojiTapSection && oldValue) {
      setTimeout(() => {
        showOnboardingEmojiNavbarImprove.value = true
      }, 500)
    }
  })

  watch(showOnboardingEmojiCard, (showOnboardingEmojiCard, oldValue) => {
    if (!showOnboardingEmojiCard && oldValue) {
      setTimeout(() => {
        showOnboardingEmojiNavbarQuests.value = true
      }, 1000)
    }
  })

  watch(showOnboardingEmojiQuest, (showOnboardingEmojiQuest, oldValue) => {
    if (!showOnboardingEmojiQuest && oldValue) {
      setTimeout(() => {
        showOnboardingEmojiNavbarFriends.value = true
      }, 2000)
    }
  })

  return {
    canShowOnboardingEmoji,
    showOnboardingEmojiWheel,
    showOnboardingEmojiNavbarHome,
    showOnboardingEmojiTapSection,
    showOnboardingEmojiNavbarImprove,
    showOnboardingEmojiCard,
    showOnboardingEmojiNavbarQuests,
    showOnboardingEmojiQuest,
    showOnboardingEmojiNavbarFriends,
    showOnboardingEmojiFriends,
  }
}
